import { observer } from 'mobx-react-lite';
import { Progress } from 'components/core';
import { useStoreContext } from 'store/app';
import Cover from '../../assets/img/cover.png';

import './Loading.styl';
import { useEffect, useRef, useState } from 'react';
import Label from 'components/core/Label';

export const Loading = observer(() => {
    const [percentToPrint, setPercentToShow] = useState(0);
    const { loadedPercent } = useStoreContext();
    const timerRef = useRef<NodeJS.Timeout>(undefined);

    useEffect(() => {
        if (percentToPrint < loadedPercent) {
            timerRef.current = setTimeout(() => setPercentToShow(Math.min(percentToPrint + 2, loadedPercent)), 30);
        }
    }, [loadedPercent, percentToPrint]);

    useEffect(() => {
        return () => {
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, []);

    return (
        <div className="main-loader" style={{ backgroundImage: `url(${Cover})` }}>
            <div className="main-loader-bottom">
                <div className="main-loader-bottom-title">
                    <Label of="loading.title" isRawHtml fallback="Собирайте коллекции и&nbsp;выигрывайте призы"></Label>
                </div>
                <div className="main-loader-bottom-desc">
                    <Label of="loading.desc" isRawHtml fallback="Официальный проект Одноклассников"></Label>
                </div>
                <Progress className="main-loader-bottom-progress" total={100} progress={percentToPrint || 0} />
                <div className="main-loader-bottom-percent">{`${percentToPrint}%`}</div>
            </div>
        </div>
    );
});
